import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
    current: {},
    availables: [],
    setup: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(dvr => ({
        value: dvr.id,
        label: dvr.name,
      }))
    },
    getCurrent(state) {
      return state.current
    },
    getAvailables(state) {
      return state.availables
    },
    getSetup(state) {
      return state.setup
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setDataCurrent(state, value) {
      state.current = value
    },
    setDataAvailable(state, value) {
      state.availables = value
    },
    setDataSetup(state, value) {
      state.setup = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/hanwha/camera', { params })

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },
     async add(_, params) {
      const { data } = await axios.post(`v1/hanwha/camera`, params)

      return data
    },
    async discover(_, params) {
      const { data } = await axios.post('v1/hanwha/camera/admin/discover', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/hanwha/camera/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/hanwha/camera/${id}`)

      return data
    },
    async getVideoProfileSetup({ commit }, id) {
      const { data } = await axios.get(`v1/services/device/video_profile/${id}/availables_setup`)

      if (!data) {
        return []
      }

      commit('setDataSetup', data.data)
      return data
    },
    async getVideoProfileAvailables({ commit }, id) {
      const { data } = await axios.get(`v1/services/device/video_profile/${id}/availables`)

      if (!data) {
        return []
      }

      commit('setDataAvailable', data.data)
      return data
    },
    async getCurrentVideoProfile({ commit }, id) {
      const { data } = await axios.get(`v1/services/device/video_profile/${id}/current`)

      if (!data) {
        return []
      }

      commit('setDataCurrent', data.data)
      return data
    },
    clear({ commit }) {
      commit('setData', [])
    },
    async saveTransmitionConfig(_, { id, params }) {
      const { data } = await axios.post(`v1/services/device/video_profile/${id}/update`, params)

      return data
    },
  },
}
